import type { SxProps } from '@mui/material';

import { useState } from 'react';
import { useBoolean, useCopyToClipboard } from 'usehooks-ts';

import { useTheme } from '@mui/material';

import { FEEDBACK } from 'src/utils/constants';

import { Iconify } from 'src/components/iconify/iconify';

import CheckIcon from './components/CheckIcon';
import StyledTooltip from './components/StyledTooltip';
import ForwardedStyledButton from './components/StyledButton';

type Props = { content: string; sx?: SxProps };

// const MotionCopyIcon = m(<Iconify icon="material-symbols:content-copy" />);

function CopyButton({ content, ...others }: Props) {
  const theme = useTheme();
  const [, copy] = useCopyToClipboard();
  const { value, toggle } = useBoolean(false);
  const [title, setTitle] = useState<string | null>(FEEDBACK.TOOLTIP.COPY);

  const handleCopy = async () => {
    copy(content).then(() => {
      toggle();
      setTitle(null);

      setTimeout(() => {
        toggle();
      }, FEEDBACK.ANIMATION_TIME);
    });
  };

  const renderedContent = (
    <ForwardedStyledButton
      onClick={handleCopy}
      onMouseLeave={() => setTitle(FEEDBACK.TOOLTIP.COPY)}
      className="copy-button"
    >
      {value ? (
        <CheckIcon />
      ) : (
        <Iconify
          icon="material-symbols:content-copy-outline"
          width={16}
          color={theme.palette.text.secondary}
          {...others}
        />
      )}
    </ForwardedStyledButton>
  );

  if (!title) {
    return <>{renderedContent}</>;
  }

  return <StyledTooltip title={title}>{renderedContent}</StyledTooltip>;
}

export default CopyButton;
